<template>
  <main style="display: block">
    <div class="home-banner relative h-[479px] flex-none">
      <div class="home-banner-bg absolute inset-0">
        <img
          class="w-full h-full object-cover absolute top-0 left-0"
          src="../assets/img/bg.png"
          alt=""
        />
      </div>
      <div
        class="home-banner-content content relative h-full flex items-center"
      >
        <div>
          <h1
            class="text-[80px] mb-[16px]"
            style="color: #1a1a1a; font-weight: 600"
          >
            司普科技
          </h1>
          <h2 class="text-[28px] font-normal mb-[40px]">
            企业级多模态AI原生应用服务领航者
          </h2>
          <div class="btn" @click="router.push('/demo')">预约演示</div>
        </div>
      </div>
    </div>
    <slot></slot>
  </main>
</template>

<script setup lang="ts">
const router = useRouter()
</script>

<style lang="scss" scoped>
.content {
  max-width: 1080px;
  margin: 0 auto;
}
.btn {
  background: #3d6bff;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  height: 34px;
  line-height: 34px;
  text-align: center;
  width: 104px;
  transition: all 0.3s ease;
  &:hover {
    background: #0d56e8;
  }
}
</style>
